<template>
  <van-popup v-model="siteshow" position="bottom" :overlay="true">
    <div>
      <van-nav-bar @click-left="onClickLeft" @click-right="onClickRight">
        <div slot="left">取消</div>
        <div slot="right">确定</div>
      </van-nav-bar>
      <mt-picker :slots="slots1" @change="slots1Change" valueKey="name" :visibleItemCount="7"></mt-picker>
      <mt-picker :slots="slots2" @change="slots2Change" valueKey="name" :visibleItemCount="7"></mt-picker>
      <mt-picker :slots="slots3" @change="slots3Change" valueKey="name" :visibleItemCount="7"></mt-picker>
      <mt-picker :slots="slots4" @change="slots4Change" valueKey="name" :visibleItemCount="7"></mt-picker>
    </div>
  </van-popup>
</template>

<script>
/**
 * 地址选择弹框
 */
import 'mint-ui/lib/style.css'
import Vue from 'vue'
import { Picker } from 'mint-ui'

Vue.component(Picker.name, Picker)
export default {
  name: 'bugoods',
  props: {
    jd: {
      default: false
    },
    jdSiteDefault: {
      default: false
    }
  },
  watch: {
    jdSiteDefault(val) {
      if (val && +this.town.id) {
        this.onClickRight()
      }
    }
  },
  data() {
    return {
      datas: 123,
      siteshow: false,
      slots1: [
        {
          flex: 1,
          values: [{ name: '请选择' }],
          className: 'slot1',
          textAlign: 'center'
        }
      ],
      slots2: [
        {
          flex: 1,
          values: [{ name: '请选择' }],
          className: 'slot2',
          textAlign: 'left'
        }
      ],
      slots3: [
        {
          flex: 1,
          values: [{ name: '请选择' }],
          className: 'slot3',
          textAlign: 'left'
        }
      ],
      slots4: [
        {
          flex: 1,
          values: [{ name: '请选择' }],
          className: 'slot4',
          textAlign: 'left'
        }
      ],
      province: '',
      city: '',
      town: '',
      county: '',
      isCounty: false
    }
  },
  methods: {
    getAddress() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      var _this = this;
      this.$api.get(
        "user/address/list",
        { id_example: mallid, token_user: isUser },
        res => {
          if (res.data.code == "100") {
            res.data.data.forEach(item => {
              if (item.default == 1) {
                var area = "";
                area += item.province_str;
                area += "-" + item.city_str;
                area += "-" + item.county_str;
                if (item.town_str != "") {
                  area += "-" + item.town_str;
                }
                var json = {
                  area: area,
                  province_id: item.province,
                  city_id: item.city,
                  country_id: item.county,
                  town_id: item.town ? item.town : 0
                };
                this.$store.commit("setAddress", json);
              }
            });
          }
        }
      );
    },
    setSiteShow() {
      this.siteshow = !this.siteshow
    },
    onClickLeft() {
      this.siteshow = !this.siteshow
    },
    onClickRight() {
      if (!+this.province.id || !+this.city.id || !+this.town.id) {
        return this.$toast('请选择完整的省/市/区/县')
      }
      if (this.isCounty && !+this.county.id) {
        return this.$toast('请选择完整的省/市/区/县')
      }
      this.siteshow = false
      this.$emit('listenSitedata', [this.province, this.city, this.town, this.county])
    },
    // 一级地址选择
    slots1Change(picker, values) {
      if (values[0].name != '请选择') {
        this.slots2[0].values = [{ name: '请选择' }]
        this.slots3[0].values = [{ name: '请选择' }]
        this.slots4[0].values = [{ name: '请选择' }]
        var id = values[0].id
        this.$api.post('address/address/getCity', { area_id: id }, res => {
          if (res.data.code == 100) {
            this.slots2[0].values = this.slots2[0].values.concat(res.data.data)
          }
        })
      } else {
        this.slots2[0].values = [{ name: '请选择' }]
        this.slots3[0].values = [{ name: '请选择' }]
        this.slots4[0].values = [{ name: '请选择' }]
      }
      this.province = values[0]
      this.city = []
      this.town = []
      this.county = []
    },
    // 二级地址选择
    slots2Change(picker, values) {
      if (values[0].name != '请选择') {
        this.slots3[0].values = [{ name: '请选择' }]
        this.slots4[0].values = []
        var id = values[0].id
        this.$api.post('address/address/getCounty', { area_id: id }, res => {
          if (res.data.code == 100) {
            this.slots3[0].values = this.slots3[0].values.concat(res.data.data)
          }
        })
      } else {
        this.slots3[0].values = [{ name: '请选择' }]
        this.slots4[0].values = [{ name: '请选择' }]
      }
      this.city = values[0]
      this.town = []
      this.county = []
    },
    // 三级地址选择
    slots3Change(picker, values) {
      var _this = this
      this.isCounty = false
      if (values[0].name != '请选择') {
        this.slots4[0].values = [{ name: '请选择' }]
        var id = values[0].id
        this.$api.post('address/address/getTown', { area_id: id }, res => {
          if (res.data.code !== 100) {
            return false
          }
          if (res.data.data && res.data.data.length > 0) {
            this.slots4[0].values = this.slots4[0].values.concat(res.data.data)
            this.isCounty = true
          } else {
            this.slots4[0].values = [{ name: ' ' }]
          }
        })
      } else {
        this.slots4[0].values = [{ name: '请选择' }]
      }
      this.town = values[0]
      this.county = []
    },
    // 四级地址
    slots4Change: function (picker, values) {
      this.county = values[0]
    },
    // 基本地址
    getDatas() {
      this.$api.post('/address/address/getProvince', {}, res => {
        if (res.data.code == 100) {
          this.slots1[0].values = this.slots1[0].values.concat(res.data.data)
        }
      })
    }
  },
  mounted() {
    this.getAddress()
    this.getDatas()
  }
}
</script>

<style scoped lang="less">
.picker {
  width: 25%;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/mysite/cityPicker.vue